<template>
  <div>
    <!-- <OrderedItemBaseCard
      :name="merch.name"
      :original-price="displayedOriginalPrice"
      :current-price="itemPrice"
      :clear="!item.isNotAllowedSelect && !isBelongAddOn(item) && merch.changeable"
      :show-deal="merch.currentPrice != merch.originalPrice"
      :quantity="item.quantity"
      @clear="removeItem"
    /> -->
    <div 
      class="merch-card-container flex flex-col gap-1.5 px-2.5 py-2"
      :class="!reachToMax ? 'changed' : ''"
    >
      <div class="upper-container w-full flex justify-between items-start">
        <div class="quantity-name-conatiner w-3/4 gap-1 items-center inline-block">
          <div class="inline-block">
            <div class="quantity-container flex justify-between mr-1.5">
              <span 
                class="remove material-icons flex items-center cursor-pointer"
                :class="!merch.editable || item.quantity === 0  || isCheckoutPageInAddon ? 'disabled' : ''"
                @click="decreaseQuantiy"
              >
                remove
              </span>
              <span class="quantity flex items-center h-full pt-0.5">{{ item.quantity }}</span>
              <span 
                class="add material-icons flex items-center cursor-pointer"
                :class="reachToMax || !merch.editable || isCheckoutPageInAddon ? 'disabled' : ''"
                @click="addQuantity"
              >
                add
              </span>
            </div>            
          </div>

          <div class="name inline" :class="!reachToMax ? 'changed' : ''">{{ merch.name }}</div>
        </div>
        <div class="flex items-center gap-2">
          <div class="name mr-2">{{ currencySymbol + (merch.currentPrice * item.quantity).toFixed(2) }}</div>
          <div class="clear-container flex justify-end">
            <span 
              v-if="item.quantity > 0 && merch.editable && !isCheckoutPageInAddon" 
              class="material-icons-outlined clear-icon cursor-pointer" 
              @click="removeAll"
            >
              clear
            </span>
          </div>
        </div>
      </div>
      <div class="w-full down-container flex flex-col">
        <div>
          <span v-if="!reachToMax" class="red-text">{{ removeText }}</span>
        </div>
        {{  }}
        <div v-if="merch.editable" class="flex justify-between">
          <span class="grey-text">Returned eligible</span>
          <span class="normal-text" v-if="returnable">until {{ formattedReturnDay }}</span>
        </div>
        <div v-else class="flex justify-between">
          <span class="grey-text">Return closed</span>
          <span class="normal-text" v-if="returnable">{{ formattedReturnDay }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from 'moment'

export default {
  components: {
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },

  },
  data() {
    return {
      originalQuantity: 0,
    }
  },
  computed: {
    ...mapState(["currency"]),
    ...mapState("orderTest", ["isAddOnOrder"]),
    ...mapState("orderTest/order", ["editOrderSampleId"]),
    ...mapState("orderTest/user", ["userInfo"]),

    currencySymbol() {
      return this.currency ? this.currency.symbol : "$";
    },

    merch() {
      return this.item.merch;
    },
    
    itemPrice() {
      return this.item.quantity * this.merch.currentPrice;
    },
    reachToMax() {
      return this.item.quantity === this.merch.quantityInEditOrder;
    },

    returnable() {
      return this.merch.return_and_refund_info.accept_return_refund;
    },
    formattedReturnDay() {
      return moment(this.merch.returnDeadline).format('MMM-DD-YYYY');
    },
    removeText() {
      if (this.reachToMax) {
        return "";
      }
      if (this.item.quantity === 0) {
        return "All items removed";
      } 
      const gap = this.merch.quantityInEditOrder - this.item.quantity;
      return gap + " item" + (gap === 1 ? "" : "s" ) + " removed";
    },
    isCheckoutPage(){
      return window.location.href.includes("/ordertest/checkout")
    },
    isCheckoutPageInAddon() {
      return this.isCheckoutPage && this.isAddOnOrder;
    }
  },

  emits: ["removeItem", "changeMerchQuantity"],

  mounted() {
    this.originalQuantity = this.item.quantity;
  },

  methods: {
    // removeItem() {
    //   this.$store.commit("orderTest/merchandise/REMOVE_ITEM_FROM_SELECTED_MERCH_MAP", this.item.id);
    // },
    decreaseQuantiy() {
      if (!this.merch.editable || this.item.quantity === 0 || this.isCheckoutPageInAddon) {
        return;
      }
      this.$store.dispatch("orderTest/merchandise/removeFromSelectedMerchMap", this.item.id);
      if (this.isCheckoutPage) {
        this.$emit("changeMerchQuantity");
      }
    },
    addQuantity() {
      if (this.reachToMax || !this.merch.editable  || this.isCheckoutPageInAddon) {
        return;
      }
      this.$store.dispatch("orderTest/merchandise/addToSelectedMerchMap", this.item.id);
      if (this.isCheckoutPage) {
        this.$emit("changeMerchQuantity");
      }
    },

    removeAll() {
      this.$store.dispatch("orderTest/merchandise/removeAllQuantityInEditOrder", this.item.id);
      if (this.isCheckoutPage) {
        this.$emit("changeMerchQuantity");
      }
    }
  }
};
</script>

<style scoped>
.merch-card-container {
  background: var(--color-background-Blue-BG, #F9FBFD);
}

.merch-card-container.changed {
  background: var(--color-Functional-Red-alert-bg, #FAEAEA);
}

.quantity-container {
  width: 70px;
  height: 18px;
  border-radius: var(--radius, 4px);
  border: 1px solid var(--color-Cyan-000, #20A7C1);
  background: var(--color-background-Blue-BG, #F9FBFD);
}

.quantity {
  height: 100%;
}

.add, .remove {
  max-width: 16px;
  font-size: 14px;
  color: var(--color-Cyan-000, #20A7C1);
}

.quantity {
  font-size: 14px;
}

.remove {
  border-right: 1px solid var(--color-Cyan-000, #20A7C1);
}

.add {
  border-left: 1px solid var(--color-Cyan-000, #20A7C1);
}

.name {
  color: #000;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.4px;  
}

.changed.name {
  color: var(--color-Red-000, #FF1D00);
}

.clear-container {
  width: 14px
}

.grey-text {
  color: var(--color-Grey-Grey-97, #979797);
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.normal-text {
  color: #000;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.clear-icon {
  font-size: 14px;
  color: var(--color-Cyan-000, #20A7C1);
}

.disabled {
  cursor: not-allowed;
}

.disabled.add {
  color: rgba(201, 202, 205, 1);
  border-left: 1px solid rgba(201, 202, 205, 1);
}

.disabled.remove {
  color: rgba(201, 202, 205, 1);
  border-right: 1px solid rgba(201, 202, 205, 1);
}

.red-text {
  color: #F00;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
